
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type scrollButtonRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function scrollButtonRT(): TemplateResult<scrollButtonRTRootProps> {
    return _createElement('span', {}, [_createElement('svg', {
            'className': 'cm_icon',
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '11',
            'height': '16',
            'viewBox': '0 0 11 16',
            'fill': 'none',
            'key': '60'
        }, _createElement('path', {
            'd': 'M5.5 5.02681e-07C5.60065 4.93482e-07 5.69757 0.014319 5.79074 0.042954C5.88449 0.071589 5.96732 0.128859 6.03921 0.214765L10.8059 4.96107C10.9353 5.07561 11 5.22251 11 5.40177C11 5.58046 10.9353 5.73423 10.8059 5.86309C10.6765 5.97763 10.5218 6.0349 10.3417 6.0349C10.1623 6.0349 10.0078 5.97763 9.87843 5.86309L6.14706 2.12618L6.14706 15.3557C6.14706 15.5418 6.0858 15.6959 5.96329 15.8179C5.84136 15.9393 5.68693 16 5.5 16C5.31307 16 5.15835 15.9393 5.03584 15.8179C4.91391 15.6959 4.85294 15.5418 4.85294 15.3557L4.85294 2.12618L1.1 5.86309C0.984965 5.97763 0.837436 6.03862 0.65741 6.04607C0.477959 6.05294 0.323528 5.99195 0.194117 5.86309C0.064705 5.73423 -1.82663e-06 5.58046 -1.8416e-06 5.40177C-1.85661e-06 5.22252 0.0647049 5.07562 0.194117 4.96107L4.96078 0.214765C5.03268 0.128859 5.11521 0.0715891 5.20839 0.042954C5.30214 0.014319 5.39935 5.1188e-07 5.5 5.02681e-07Z',
            'fill': 'currentColor'
        }))]);
}
        export const componentNames = []